import spartaStoreUtility from "global/sparta-store-utility";
function insertPositionInOptions(options, insert) {
  return Object.assign({}, options, { insert });
}

class spartaMessageUtility {
  constructor() {
    this._options = {
      listType: 'ordered',
      dismiss: false,
      border: null,
      insert: 'before',
      size: 'large',
      uuid: (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1),
    };


    this._type = 'info';

    this.language = spartaStoreUtility.getData('lang');
  }

  title(title) {
    if (title) { this._title = title; }

    return this;
  }

  message(msg) {
    if (msg) { this._message = msg; }

    return this;
  }

  type(type) {
    if (type) { this._type = type; }

    return this;
  }

  show(target, localOptions = {}) {
    this._target = target;


    const opts = Object.assign({}, this._options, localOptions);
    this._options = opts;


    const template = this.buildTemplate();


    this.attach(template);
    this.addListeners();

    return this;
  }

  buildTemplate() {
    const content = this.formatMessage();
    let style = '';
    let dismiss = '';

    if (this._options.border !== null) {
      style = `style="border-width: ${this._options.border}"`;
    }

    if (this._options.dismiss) {
      if (this.language === 'es-us') {
        dismiss = `<a href="#" class="spartaMessage-close-x"><span aria-hidden="true">×</span><span class="ada-hidden">Mensaje de despido</span></a>`;
      } else {
        dismiss = `<a href="#" class="spartaMessage-close-x"><span aria-hidden="true">×</span><span class="ada-hidden">Dismiss Message</span></a>`;
      }
    }

    const lang = spartaStoreUtility.getData('jcrLang');


    const spaParams = spartaStoreUtility.getData('spaParams').global[lang];


    const messageIcons = spaParams.messagingIcons;


    const icon = messageIcons[this._type];


              <div class="spartaMessage-icon">
                <span class="data-icon">
                  ${icon}
                </span>
              </div>
              <div class="spartaMessage-content">
                ${title}
                ${content}
              </div>
              <div class="spartaMessage-dismiss">
                ${dismiss}
              </div>
            </div>`;
  }

  formatMessage() {
    if (Array.isArray(this._message)) {
      let str = '';
      let startWrap = '';
      let endWrap = '';

      if (this._options.listType === 'ordered' || this._options.listType === 'unordered') {
        startWrap = '<li>';
        endWrap = '</li>';
      }

      if (this._options.listType === 'paragraph') {
        startWrap = '<p>';
        endWrap = '</p>';
      }

      str += (this._options.listType === 'ordered') ? '<ul class="spartaMessage-list">' : '';
      str += (this._options.listType === 'unordered') ? '<ol class="spartaMessage-list">' : '';

      this._message.forEach((item) => {
        str += `${startWrap}${item}${endWrap}`;
      });

      str += (this._options.listType === 'ordered') ? '</ul>' : '';
      str += (this._options.listType === 'unordered') ? '</ol>' : '';

      return str;
    }

    return (this._message !== '') ? `<p class="spartaMessage-text">${this._message}</p>` : '';
  }

  destroy() {
    const { uuid } = this._options;

    if (!uuid) return false;

    const id = `sparta-message-${uuid}`;

    const element = document.getElementById(id);

    if (element) {
      element.parentNode.removeChild(element);
    }

    return false;
  }

  attach(template) {
    const el = document.querySelector(this._target);

    switch (this._options.insert) {
      case 'before':
        el.insertAdjacentHTML('beforebegin', template);
        break;

      case 'after':
        el.insertAdjacentHTML('afterend', template);
        break;

      case 'insideFirst':
      case 'prepend':
        el.insertAdjacentHTML('afterbegin', template);
        break;

      case 'insideLast':
      case 'append':
        el.insertAdjacentHTML('beforeend', template);
        break;

      case 'replace':
      default:
        el.innerHTML = template;
    }

    // NOTE: seems like if content changes dynamically this will cause the background to not resize
    // correctly.
    //
    // after we attach, set the height of the icon div to the height of the containing div
    // const selector = `#sparta-message-${this._options.uuid} .spartaMessage-icon`;
    // const parentHeight = document.querySelector(selector).parentNode.offsetHeight;
    // document.querySelector(selector).style.height = `${parentHeight}px`;
  }

  addListeners() {
    // setup a listener for resize.
    // window.onresize = function (event) {
    //   const selector = `#sparta-message-${this._options.uuid} .spartaMessage-icon`;
    //   const parentHeight = document.querySelector(selector).parentNode.offsetHeight;
    //   document.querySelector(selector).style.height = `${parentHeight}px`;
    // }.bind(this);

    if (this._options.dismiss) {
      const closeIconSelector = `#sparta-message-${this._options.uuid} .spartaMessage-close-x`